import { MultiSectionLayout, TabsLayout } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";
import React, { useEffect, useState } from "react";
import { SideMenuLayout } from "@jugl-web/ui-kit";
import { useInstagramAccount } from "../../../../providers/InstagramAccountProvider/useInstagramAccount";
import { InstagramGeneralInfoTab } from "./components/InstagramGeneralInfoTab";
import { ReactComponent as InfoIcon } from "./assets/info.svg";
import { InstagramAccountMenuTab, InstagramAccountTab } from "./types";

export const InstagramAccountScreen: React.FC<{
  tab?: InstagramAccountTab;
}> = ({ tab }) => {
  const { t } = useTranslations();
  const { instagramAccount } = useInstagramAccount();

  const [selectedTab, setSelectedTab] = useState<InstagramAccountTab>(
    InstagramAccountTab.account
  );

  const [selectedMenuTab, setSelectedMenuTab] =
    useState<InstagramAccountMenuTab>(InstagramAccountMenuTab.generalInfo);

  useEffect(() => {
    if (tab) {
      setSelectedTab(tab);
    }
  }, [tab]);

  return (
    <TabsLayout
      selectedTab={selectedTab}
      tabs={[
        {
          id: InstagramAccountTab.account,
          title: t({
            id: "client-support-page.account",
            defaultMessage: "Account",
          }),
          onClick: () => setSelectedTab(InstagramAccountTab.account),
        },
      ]}
    >
      <MultiSectionLayout
        classNames={{ content: "flex flex-col gap-8 p-8 bg-grey-100" }}
        leftSide={
          selectedTab === InstagramAccountTab.account &&
          instagramAccount?.status === "connected" && (
            <div className="border-dark-200 jugl__custom-scrollbar h-full w-[320px] overflow-y-auto border-0 border-r border-solid py-10 px-4">
              <SideMenuLayout
                items={[
                  {
                    id: InstagramAccountMenuTab.generalInfo,
                    label: t({
                      id: "client-support-page.general-info",
                      defaultMessage: "General Info",
                    }),
                    icon: <InfoIcon />,
                  },
                ]}
                selectedItem={selectedMenuTab}
                onItemClick={(item) =>
                  setSelectedMenuTab(item.id as InstagramAccountMenuTab)
                }
              />
            </div>
          )
        }
      >
        {(() => {
          if (selectedTab === InstagramAccountTab.account) {
            switch (selectedMenuTab) {
              case InstagramAccountMenuTab.generalInfo:
                return <InstagramGeneralInfoTab />;
              default:
                return null;
            }
          }

          return null;
        })()}
      </MultiSectionLayout>
    </TabsLayout>
  );
};
